"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

var _regeneratorRuntime = require("/opt/build/repo/docs/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.function.bind");

var _classCallCheck = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _possibleConstructorReturn = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDidSession = withDidSession;
exports.DidSessionContext = exports.DidSessionConsumer = exports.DidSessionProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _querystring = _interopRequireDefault(require("querystring"));

var _Login = _interopRequireDefault(require("@arcblock/did-react/lib/Auth/Login"));

var _Service = _interopRequireDefault(require("@arcblock/did-react/lib/Service"));

var _Storage = _interopRequireDefault(require("@arcblock/did-react/lib/Storage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DidSessionContext = _react["default"].createContext();

exports.DidSessionContext = DidSessionContext;
var Provider = DidSessionContext.Provider,
    Consumer = DidSessionContext.Consumer;
exports.DidSessionConsumer = Consumer;
var storage = (0, _Storage["default"])('did.connect.token');
var getToken = storage.getToken,
    setToken = storage.setToken,
    removeToken = storage.removeToken;
/**
 * Defines a SessionProvider from DID:Connect Service
 *
 * @class DidSessionProvider
 * @extends {React.Component}
 */

var DidSessionProvider = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(DidSessionProvider, _react$default$Compon);

  var _super = _createSuper(DidSessionProvider);

  function DidSessionProvider(props) {
    var _this;

    _classCallCheck(this, DidSessionProvider);

    _this = _super.call(this, props);
    _this.service = (0, _Service["default"])(props.serviceHost, storage);
    _this.state = {
      error: '',
      open: false,
      user: null
    };
    _this.onLogin = _this.onLogin.bind(_assertThisInitialized(_this));
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    _this.login = _this.login.bind(_assertThisInitialized(_this));
    _this.logout = _this.logout.bind(_assertThisInitialized(_this));
    _this.refresh = _this.refresh.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DidSessionProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var token = getToken();

      if (token) {
        this.refresh();
        return;
      } // If a login token exist in url, set that token in storage


      if (!window || !window.location) {
        return;
      }

      var params = _querystring["default"].parse(window.location.search.slice(1));

      if (params.loginToken) {
        setToken(params.loginToken);
        this.refresh();
        delete params.loginToken;
        var redirectUrl = "".concat(window.location.pathname, "?").concat(_querystring["default"].stringify(params));
        window.history.replaceState({}, window.title, redirectUrl);
      }
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, appDid, authAPIPrefix, _yield$this$service$g, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this$props = this.props, appDid = _this$props.appDid, authAPIPrefix = _this$props.authAPIPrefix;
                _context.next = 4;
                return this.service.get("".concat(authAPIPrefix || '/api/agent', "/").concat(appDid, "/session").replace(/\/+/, '/'));

              case 4:
                _yield$this$service$g = _context.sent;
                data = _yield$this$service$g.data;

                if (data.error) {
                  this.setState({
                    error: data.error,
                    open: false
                  });
                }

                if (data.user) {
                  this.setState({
                    user: data.user,
                    open: false
                  });
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                this.setState({
                  error: _context.t0.message,
                  open: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "login",
    value: function login() {
      if (this.state.user) {
        return;
      }

      this.setState({
        open: true
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      removeToken();
      this.setState({
        user: null,
        error: ''
      });
    }
  }, {
    key: "onLogin",
    value: function onLogin(_ref) {
      var loginToken = _ref.loginToken;

      if (loginToken) {
        setToken(loginToken);
        this.refresh();
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line object-curly-newline
      var _this$props2 = this.props,
          children = _this$props2.children,
          appDid = _this$props2.appDid,
          authAction = _this$props2.authAction,
          authAPIPrefix = _this$props2.authAPIPrefix,
          locale = _this$props2.locale,
          extraParams = _this$props2.extraParams;
      var _this$state = this.state,
          user = _this$state.user,
          open = _this$state.open,
          error = _this$state.error;
      var state = {
        session: {
          appDid: appDid,
          error: error,
          loading: open,
          user: user,
          login: this.login,
          logout: this.logout
        }
      };
      return _react["default"].createElement(Provider, {
        value: state
      }, typeof children === 'function' ? children(state) : children, open && _react["default"].createElement(_Login["default"], {
        action: authAction || 'profile',
        locale: locale,
        prefix: "".concat(authAPIPrefix || '/api/agent', "/").concat(appDid),
        checkFn: this.service.get,
        onClose: this.onClose,
        onSuccess: this.onLogin,
        extraParams: extraParams,
        checkTimeout: 3 * 60 * 1000
      }));
    }
  }]);

  return DidSessionProvider;
}(_react["default"].Component);

exports.DidSessionProvider = DidSessionProvider;
DidSessionProvider.propTypes = {
  children: _propTypes["default"].any.isRequired,
  appDid: _propTypes["default"].string.isRequired,
  serviceHost: _propTypes["default"].string.isRequired,
  authAction: _propTypes["default"].string,
  authAPIPrefix: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  extraParams: _propTypes["default"].object
};
DidSessionProvider.defaultProps = {
  locale: 'en',
  authAction: 'profile',
  authAPIPrefix: '/api/agent',
  extraParams: {}
};

function withDidSession(Component) {
  return function WithSessionComponent(props) {
    return _react["default"].createElement(Consumer, null, function (sessionProps) {
      return _react["default"].createElement(Component, Object.assign({}, props, sessionProps));
    });
  };
} // eslint-disable-next-line object-curly-newline